import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store= new Vuex.Store({
  state: {
    loginRedirect: "",
    payOrder:""
  },
  mutations: {
    setLoginRedirect(state, from) {
      state.loginRedirect = from;
    },
    setPayOrder(state, order) {
      state.payOrder = order;
    }
  },
  getters: {
    getLoginRedirect(state) {
      return state.loginRedirect;
    },
    getPayOrder(state) {
      return state.payOrder;
    }
  },
  actions: {},
  modules: {}
})
export default store
